import React, { useState } from 'react'
import { IconButton, Box, Tooltip } from '@mui/material'
import SyncIcon from '@mui/icons-material/Sync'
import liveDataService from '../../service/hmiUpdate.service'

export const TOOLTIP = {
  mode: 'index',
  xAlign: 'center',
  yAlign: 'bottom',
  titleAlign: 'center',
  bodyAlign: 'center',
  backgroundColor: '#282c34',
  bodyColor: '#fff'
}

const RefreshDataButton = ({ onRefresh }) => {
  const [loading, setLoading] = useState(false)

  const handleRefresh = async () => {
    try {
      setLoading(true)
      await liveDataService.getRefreshLatestData()
      if (onRefresh) {
        await onRefresh()
      }
    } catch (err) {
      console.error('Refresh data failed', err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Tooltip
        title="Refresh data"
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: TOOLTIP.backgroundColor,
              color: TOOLTIP.bodyColor,
              textAlign: TOOLTIP.bodyAlign
            }
          },
          arrow: { sx: { color: TOOLTIP.backgroundColor } }
        }}
      >
        <IconButton
          loading={loading}
          disabled={loading}
          color="primary"
          size="small"
          onClick={handleRefresh}
          sx={{
            backgroundColor: '#f5f5f5',
            borderRadius: '50%',
            boxShadow: 1,
            p: 1.5,
            '&:hover': { backgroundColor: '#e0e0e0' }
          }}
        >
          <SyncIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export default RefreshDataButton
